import React from 'react'

import './style.css'
import { FormattedMessage } from 'react-intl'

export function HorizontalRule() {
  return (
    <div className="horizontal-rule margin-vertical-24 shade-10">
      <label>
        <FormattedMessage
          id="boarding.horizontalRule"
          defaultMessage="or"
          values={{}}
        />
      </label>
    </div>
  )
}
